import type { DisplayStyleType, WidgetChartType } from '@/dashboard/shared/types/widgets.types';
import { LayoutItemRequired } from 'vue3-grid-layout-next/dist/helpers/utils';

export const WIDGET_COPY_SIGNATURE = 'EXEM_ONE_WIDGET_COPY_V1';

export const WIDGET_COPY_BUFFER_TTL_MS = 30 * 60 * 1000; // 30 minutes

export const WIDGET_COPY_BUFFER_VERSION = 1;

export const GRID_LAYOUT_OPTION_MULTIPLIER = 2;
export const GRID_LAYOUT_OPTION = {
  COL_NUM: 32,
  ROW_NUM: 44,
  MIN_WIDTH: 4,
  MIN_HEIGHT: 6,
  MIN_ROW_HEIGHT: 16,
  MARGIN: [8, 8],
  GROUP_INNER_MARGIN: [4, 4],
  DEFAULT_WIDTH: 8,
  DEFAULT_HEIGHT: 12,
};

export type LayoutItemSize = Pick<LayoutItemRequired, 'w' | 'h'> & {
  minH: number;
  minW: number;
};
export const getDefaultWidgetSize = (
  widgetType: WidgetChartType,
  displayStyle: DisplayStyleType = '',
): LayoutItemSize => {
  const defaultSizeMap = {
    GROUP: {
      '': {
        w: 32,
        h: 4,
      },
    },
    TAB_GROUP: {
      '': {
        w: 32,
        h: 4,
      },
    },
    TEXT: {
      '': {
        w: 8,
        h: 2,
      },
    },
    HORIZONTAL_FILTER: {
      HORIZONTAL: {
        w: 28,
        h: 6,
      },
      VERTICAL: {
        w: 8,
        h: 20,
      },
    },
    VERTICAL_FILTER: {
      HORIZONTAL: {
        w: 28,
        h: 6,
      },
      VERTICAL: {
        w: 8,
        h: 20,
      },
    },
  };
  const defaultSize = defaultSizeMap[widgetType]?.[displayStyle] ?? {
    w: GRID_LAYOUT_OPTION.DEFAULT_WIDTH,
    h: GRID_LAYOUT_OPTION.DEFAULT_HEIGHT,
  };

  const isGroup = ['TAB_GROUP', 'GROUP'].includes(widgetType);
  const isText = widgetType === 'TEXT';

  const minW = isGroup ? 1 : GRID_LAYOUT_OPTION.MIN_WIDTH;
  const minH = isGroup || isText ? 1 : GRID_LAYOUT_OPTION.MIN_HEIGHT;

  return {
    ...defaultSize,
    minW,
    minH,
  } satisfies LayoutItemSize;
};
